export default function FromCacheCallout({ analytics }) {
  return analytics && analytics.fromCache ? (
    <div
      style={{
        marginBottom: 12,
        color: "rgba(33, 33, 33, 0.5)",
        fontStyle: "italic"
      }}
    >
      Showing cached results (last updated{" "}
      {analytics.precomputedAt
        ? new Date(analytics.precomputedAt).toLocaleString()
        : "unknown"}
      )
    </div>
  ) : null;
}



// WEBPACK FOOTER //
// ./src/app/components/partials/from-cache-callout.jsx